// extracted by mini-css-extract-plugin
export default {"toolbar":"FACAKG","button":"ZIHfz6","goToDesktop":"i290mj"};